import React, { useState } from 'react';
import { ReactComponent as DeleteIcon } from '../../components/svgs/deleteIcon.svg';
import Button from '../Button';


function InputWithAddButton() {
  const [inputValue, setInputValue] = useState('');
  const [items, setItems] = useState([]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleAddItem = () => {
    if (inputValue.trim() !== '') {
      setItems([...items, inputValue]);
      setInputValue('');
    }
  };

  const handleDeleteItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
  };

  return (
    <div className="input-with-add-button">
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder="Enter property name..."
        style={{marginRight: '30px'}}
      />
      <Button onClick={handleAddItem}>Add</Button>
      {items.length > 0 && (
        <ul className='added-property-container  mt-10'>
            <p className='added-property-title'>Added properties</p>
            {items.map((item, index) => (
                <li key={index} className='flex gap-10 added-property-contents mb-6'>
                {item}
                <DeleteIcon className="delete-icon mt-1.5" onClick={() => handleDeleteItem(index)} />
                </li>
            ))}
        </ul>
      )}
  
    </div>
  );
}

export default InputWithAddButton;
